import React, { useState } from "react";
import { Button, Modal, message } from "antd";

import {
  deleteProjectTask,
  getAllProjects, updateTaskAvailable
} from "../../../webServices/Apis";
import Loader from "../../Loader/Loader";



const DeleteTask = ({

  action,
  setAction,
  showTasks,
  selectedTasks,
  setShowTasks,

}) => {
  const [open, setOpen] = useState(showTasks);
  const [loading, setLoading] = useState(false)
  const [tasks, setTasks] = useState(selectedTasks.tasks || [])


  const refreshProjects = async () => {
    try {
      await getAllProjects();
    } catch (error) {
      console.log("Project fetch error", error.message)
    }
  }

  const handleRemoveTask = async (id) => {
    try {
      setLoading(true)
      const response = await deleteProjectTask(id)

      if (response?.data?.success) {

        message.success(response?.data?.message)


        setShowTasks(!showTasks)
        setAction(!action)
        setOpen(false)
        refreshProjects();
      }

    } catch (error) {
      message.error(error?.response?.data?.message)
    } finally {
      setLoading(false)
    }
  };


  const handleChange = (index, event) => {
    const { name, value } = event.target;

    // Create a new array with updated values
    const updatedTasks = [...tasks];
    updatedTasks[index][name] = value

    // Update state with new array
    setTasks(updatedTasks);
  };

  const editTaskValues = async (id) => {

    try {

      const taskToUpdate = tasks.find(task => task.id === id)

      if (!taskToUpdate) {
        message.error("No task found to update")
        return;
      }
      if (!taskToUpdate.taskBudget || String(taskToUpdate.taskBudget).trim() === "" || Number(taskToUpdate.taskBudget) < 1) {
        message.error("Task budget can not zero")
        return;
      }
      if (!taskToUpdate.task || taskToUpdate.task.length === 0) {
        message.error("Task name can not be empty")
        return;
      }

      const payload = {
        taskName: taskToUpdate.task,
        taskBudget: taskToUpdate.taskBudget
      }

      setLoading(true)
      const response = await updateTaskAvailable(
        id, selectedTasks.id, {
        ...payload
      }
      )
      if (response?.data?.success) {
        message.success(response?.data?.message)
        setShowTasks(!showTasks)
        setAction(!action)
        setOpen(false)
      }
    } catch (error) {
      console.log("Error while updating the task", error.message)
      message.error(error.response.data.message || "Error while updating task")
    } finally {
      setLoading(false)
    }
  }


  return (
    <>
      {loading && (
        <Loader />
      )}
      <Modal
      className="scrollbar-hidden"
        title="Update Task Details"
        open={open}
        onCancel={() => {
          setOpen(false);
          setShowTasks(!showTasks);
          setTasks([...selectedTasks.tasks])
        }}
        footer={[
          <Button key="cancel"
            className="border border-gray-800 bg-gray-300 px-8 py-4 mt-4"
            onClick={() => {
              setOpen(false);
              setShowTasks(!showTasks);
              setTasks([...selectedTasks.tasks])
              setAction(!action)
            }}>
            Cancel
          </Button>
        ]}
        centered
        style={{
          maxHeight: "700px",
        
          overflowY: "scroll"
        }}
      >
        <form className="space-y-4">
          {/* Dynamic Task Fields */}
          {selectedTasks.tasks?.length > 0 &&
            selectedTasks.tasks.map((taskItem, index) => (
              <div className="mb-4 mt-4" key={index}>
                <label className="block mb-1">Task {index + 1}:</label>
                <div className="flex items-center gap-2">
                  <input
                    type="text"
                    name="task"
                    className="border border-gray-800 p-2 w-full"
                    value={taskItem.task}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <input
                    type="text"
                    name="taskBudget"
                    className="border border-gray-800 p-2 w-full"
                    value={taskItem.taskBudget}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <Button
                    type="danger"
                    onClick={() => handleRemoveTask(taskItem.id)}
                    className="ml-2 border-gray-800 hover:bg-red-300"
                  >
                    Delete
                  </Button>
                </div>

                <Button
                  type="danger"
                  onClick={() => editTaskValues(taskItem.id)}
                  className="mt-2 border-gray-800 hover:bg-green-300 px-10"
                >
                  Update
                </Button>
              </div>
            ))}
        </form>
      </Modal>
    </>
  );
};

export default DeleteTask;
